class AccordionInsuarence {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector('.summary');
    this.content = this.summary.nextElementSibling;
    this.desktopElements = [
      this.el.querySelector('.ttl'),
      this.el.querySelector('.covered'),
      this.el.querySelector('.uncovered'),
    ];
    this.btn = el.querySelector('button');
    el.accordeon = this;

    this.handleResize = this.handleResize.bind(this);
    window.addEventListener('resize', this.handleResize);

    this.init();
  }

  init() {
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.elInitHeight = this.el.offsetHeight;

    this.el.style.willChange = 'height';
    this.currentMode = window.innerWidth < 1280 ? 'mobile' : 'desktop';

    this.onClickBound = (e) => this.onClick(e);
    if (this.currentMode === 'mobile') {
      this.summary.addEventListener('click', this.onClickBound);
    } else {
      this.btn.addEventListener('click', this.onClickBound);
    }
    this.shrink();
  }

  destroy() {
    this.el.style = '';
    this.desktopElements.forEach((el) => el.classList.remove('line-clamp-1'));
    if (this.onClickBound) {
      this.summary.removeEventListener('click', this.onClickBound);
      this.btn.removeEventListener('click', this.onClickBound);
      this.onClickBound = null;
    }
  }

  handleResize() {
    const newMode = window.innerWidth < 1280 ? 'mobile' : 'desktop';
    if (newMode !== this.currentMode) {
      this.destroy();
      this.init();
    }
  }

  onClick(e) {
    e.preventDefault();
    if (window.innerWidth < 1280) {
      this.el.style.overflow = 'hidden';
    }

    if (this.isClosing || !this.el.classList.contains('open')) {
      this.open();
    } else if (this.isExpanding || this.el.classList.contains('open')) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;

    if (window.innerWidth >= 1280) {
      this.desktopElements[0].classList.add('line-clamp-1');
      this.el.style.overflow = 'hidden';
    }

    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${window.innerWidth >= 1280 ? this.btn.offsetHeight : this.summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: 'ease-out',
      },
    );

    this.animation.onfinish = () => this.onAnimationFinish(false, endHeight);
    this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.classList.add('open');
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${window.innerWidth >= 1280 ? this.elInitHeight : this.summary.offsetHeight + this.content.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: 'ease-out',
      },
    );

    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open, endHeight = '') {
    if (open) {
      this.el.classList.add('open');
      if (window.innerWidth >= 1280) {
        this.desktopElements[0].classList.remove('line-clamp-1');
        this.desktopElements[1].classList.remove('line-clamp-1');
        this.desktopElements[2].classList.remove('line-clamp-1');
      }
    } else {
      this.el.classList.remove('open');
      if (window.innerWidth >= 1280) {
        this.desktopElements[1].classList.add('line-clamp-1');
        this.desktopElements[2].classList.add('line-clamp-1');
      }
    }

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    if (open) {
      this.el.style.height = 'auto';
      this.el.style.overflow = '';
    } else {
      this.el.style.height = endHeight;
      this.el.style.overflow = 'hidden';
    }
  }
}

export default AccordionInsuarence;
